/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import {
  SpecTemplateClauses,
  SpecTemplateParagraphIs,
  SpecTemplateTextIs,
} from '../job-spec-templates';
import { JobSpecDetailsDto, JobSpecParagraphDto, JobSpecSectionDto } from './job-spec.dto';

export const JobSpecMapper = entity<JobSpecDetailsDto>({
  paragraphs: arrayOf(subentity<JobSpecParagraphDto>({
    paragraphIs: enumeration(SpecTemplateParagraphIs),
    textIs: enumeration(SpecTemplateTextIs),
    sections: arrayOf(subentity<JobSpecSectionDto>({
      sectionIs: enumeration(SpecTemplateParagraphIs),
      textIs: enumeration(SpecTemplateTextIs),
      clausesAre: enumeration(SpecTemplateClauses),
    })),
  })),
});
